import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNAButton, DNAButtonProps, DNAIcon, DNAText } from '@alucio/lux-ui';
import { DNAPopover } from 'src/components/DNA';

const S = StyleSheet.create({
  flagButton: {
    marginRight: 8,
  },
});

interface ButtonProps {
  size?: DNAButtonProps['size']
  onPress: () => void;
}

export const ShareButton: React.FC<ButtonProps> = ({ onPress, size }) => {
  return (
    <DNABox shrink>
      <DNAPopover placement="top" disablePopover={['tabletPWA']}>
        <DNAPopover.Anchor>
          <DNAButton
            testID="share-icon"
            appearance="ghost"
            status="subtle"
            size={size ?? 'md'}
            iconLeft="share-fat"
            onPress={onPress}
          />
        </DNAPopover.Anchor>
        <DNAPopover.Content offset={2}>
          <DNAText colorMode="dark">
            Share document(s)
          </DNAText>
        </DNAPopover.Content>
      </DNAPopover>
    </DNABox>
  );
};

export const FlagButton: React.FC = () => {
  return (
    <DNABox shrink style={S.flagButton}>
      <DNAPopover placement="top">
        <DNAPopover.Anchor>
          <DNAIcon.Styled name="flag-fill" />
        </DNAPopover.Anchor>
        <DNAPopover.Content offset={2}>
          <DNAText colorMode="dark">
            Flag for follow-up
          </DNAText>
        </DNAPopover.Content>
      </DNAPopover>
    </DNABox>
  )
}

export const DeleteButton: React.FC<ButtonProps> = ({ onPress }) => {
  return (
    <DNAButton
      status="tertiary"
      iconRight="trash"
      onPress={onPress}
    />
  )
}
